import {FC} from 'react';
import {Card, Container, Typography} from '@mui/material';

export const Home: FC<unknown> = () => {
    return (
        <Container
            sx={{
                paddingTop: '1rem',
                width: '100%',
                height: '100%'
            }}
        >
            <Card
                sx={{
                    width: '100%',
                    height: '100%'
                }}
            >
                <Typography
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        height: '70vh',
                        justifyContent: 'center',
                        textAlign: 'center'
                    }}
                    variant='h2'
                >
                    {'Welcome to the John Deere University Administration Self-Service Portal.'}
                    <br/>
                    {'Click the tabs on the top left to get started'}
                </Typography>
            </Card>
        </Container>
    );
};
